<template>
  <div class="content">
    <div class="content-img">
      <img class="item-img" src="../../../assets/images/bg-around-foreign-affairs-map.jpg">
    </div>
    <div class="content-item">
      <div class="item-content-left">
        <div class="item-content-top" style="display: flex; padding-top: 54px">
          <i class="icon-bus" />
          <span class="item-content-top-site">乘公交</span>
        </div>
        <p><strong>省政府公交站：</strong>福州市内乘坐
          <span>23路、76路、78路、328路</span>
          到省政府公交站下车往东（省政府方向）往前20米即到
        </p>
        <p><strong>屏山公交站：</strong>福州市内乘坐
          <span>8路、18路、19路、20路、49路、75路、78路、101路、102路、109路、145路、159路、200路、310路、地铁接驳10号专线、通勤快线12</span>
          到屏山公交车站下车往北（省政府方向）约150米，左转20米即到
        </p>
        <br/>
      </div>

      <div class="item-content-right">
        <div class="item-content-top" style="display: flex; padding-top: 54px">
          <i class="icon-metro" />
          <span class="item-content-top-site">乘地铁</span>
        </div>
        <p>
          <strong>屏山地铁站：</strong>乘坐
          <span>地铁1号线</span>
          到屏山地铁站B出口往北（省政府方向）约300米，左转30米即到
        </p>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "navigation"
}
</script>

<style scoped lang='less'>
.icon-bus{
  background-image: url("../../../assets/images/icon_contact_us_bus.png");
  margin-left: 5px;
}
.icon-metro{
  background-image: url("../../../assets/images/icon_contact_us_metro.png");
}
.icon-bus,.icon-metro{
  display: inline-block;
  width: 48px;
  height: 48px;
  margin-right: 24px;
}
.content {
  width: 100%;
  position: relative;
}
.content-img{
  width: 100%;
  height: 520px;
  background: #F5F5F5;
}
.item-img{
  width: 1140px;
  height: 520px;
  vertical-align:middle
}
.content-item {
  width: 1140px;
  height: 320px;
  //margin-left: 382px;
  display: flex;
  position: relative;
  margin: auto;
  // left: 50%;
  // -webkit-transform: translateX(-50%);
  // transform: translateX(-50%);
}
.item-content-left{
  margin-right: 113px;
}
.item-content-left,.item-content-right{
  text-align: left;
  display: inline-block;
  vertical-align:middle
}
.item-content-top-site{
  width: 300px;
  height: 48px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 41px;
  vertical-align:middle
}
.item-content-left p{
  width: 501px;
  margin-left: 1px;
}
.item-content-right p{
  width: 516px;
}
.item-content-left p,.item-content-right p{
  margin-top: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3A3A3A;
}
.item-content-left p span,.item-content-right p span{
  color: #C7301E;
}
</style>



// WEBPACK FOOTER //
// src/components/home/contactUs/siderContent02.vue